import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FileConfig } from 'src/app/models/tool.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-new-fund-modal',
    templateUrl: './new-fund-modal.component.html',
    styleUrls: ['./new-fund-modal.component.scss'],
    standalone: false
})
export class NewFundModalComponent implements OnInit {

  @Input() tabsConfig: FileConfig[];
  @Output() fundSubmit: EventEmitter<{tabsConfig: FileConfig[], activeModal: NgbActiveModal}> = new EventEmitter();
  submitted = false;

  constructor(
    private activeModal: NgbActiveModal,
  ) { }

  ngOnInit() { }

  /**
   * Submit modal. Creates a new fund (tab) and sends the information with the selected configurations to the parent component (LCA)
   */

  confirmData() {
    this.submitted = true;
    if (!this.tabsConfig.some(item => !item.choosen_value)) {
      this.fundSubmit.emit({tabsConfig: this.tabsConfig, activeModal: this.activeModal});
    }
  }

}
